import { render, staticRenderFns } from "./MySwipper.vue?vue&type=template&id=052126e2&scoped=true&"
import script from "./MySwipper.vue?vue&type=script&lang=js&"
export * from "./MySwipper.vue?vue&type=script&lang=js&"
import style0 from "./MySwipper.vue?vue&type=style&index=0&id=052126e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052126e2",
  null
  
)

export default component.exports